import instance from './axios-config.js'

// 所有分类
export function typeList() {
    return instance({
        url: '/default/type/tree/list',
        method: 'post'
    })
}

// 产品详情
export function typeDetails(id) {
    return instance({
        url: '/product/list',
        method: 'post',
        data: {
            defaultTypeId: id
        }
    })
}

// 新闻类型
export function newsType() {
    return instance({
        url: '/news_type/list',
        method: 'post',
        headers: { 'Content-Type':'application/json' },
        data: { 
            current: 1, 
            pageSize: 99 
        }
    })
}

// 新闻列表
export function newsList(data) {
    return instance({
        url: '/news/list',
        method: 'post',
        headers: { 'Content-Type':'application/json' },
        data
    })
}

// 新闻详情
export function newsDetails(id) {
    return instance({
        url: '/news/get/' + id,
        method: 'post'
    })
}

// 主页调用列表
export function IndexNewsList(id) {
    return instance({
        url: '/news/list',
        method: 'post',
        headers: { 'Content-Type':'application/json' },
        data: {
            current: 1,
            pageSize: 10,
            newsType: id 
        }
    })
}

/**
 * 会展信息
 */

// 大会配置
export function getConferenceConfig(id) {
    return instance({
        url: '/config/get',
        method: 'post',
        data: {
            parentId: id
        }
    })
}

// 分类列表
export function getCategoryList(id) {
    return instance({
        url: '/category/listByParentId/' + id,
        method: 'post'
    })
}

// 文章列表
export function getArticleList(data) {
    return instance({
        url: '/article/page',
        method: 'post',
        data
    })
}

// 文章详情
export function getArticleDetails(id) {
    return instance({
        url: '/article/get/' + id,
        method: 'post'
    })
}

// 滚动文章列表
export function getScrollArticleList() {
    return instance({
        url: '/article/hotList',
        method: 'post'
    })
}

// 新接口
// 新闻类型
export function newsTypeList(data) {
    return instance({
        url: '/news_type/list',
        method: 'post',
        data
    })
}

// 你问我答
export function questionPage(data) {
    return instance({
        url: '/question/page',
        method: 'post',
        data
    })
}

// 联系我们
export function contractPage(data) {
    return instance({
        url: '/contract/page',
        method: 'post',
        data
    })
}

// 浏览新闻
export function newsBrowse(id) {
    return instance({
        url: `/news/browse/${id}`,
        method: 'post',
    })
}